import { useEffect, useCallback, useState, useMemo, useRef } from 'react'

import _ from 'lodash'

import { Settings } from 'helpers/settings-enum'
import { settingsMenuSelector } from 'slices/ui'


import { useField, useFormikContext } from 'formik'
import { useTranslation } from 'react-i18next'

import { useSelector } from 'react-redux'
import { RootState } from 'slices'
import { useAppDispatch } from 'store'

import client from 'api'

import { zeroPad } from 'helpers'


import { BaseLookup } from '../base-lookup'
import { useIxLookupContext } from 'contexts/lookup-context'
import { ixStringToInt } from 'helpers/string-utils'
import { useLookupFetch, LookupFetchConfig, useFiltersList } from 'hooks'
import { fetchLookupData, lookupDataSelector } from 'slices/lookup-data-slice'
import {
    useContextSelfCallback,
    useSelectionChangedCallback,
    useInputChangedCallback,
} from 'hooks'


const _valueExpr = 'OBJNR'

const inputRe = [
/^(?<OBJNR>\d+)$/,
]

const inputFormat = (x: any) => {
    return x ? `${x.OBJNR}` : ''
}

const shouldUpdateConfig: any[] = []

const fetchConfig: LookupFetchConfig = {
    url: '/api/ixweb/obj/',
    fields: 'HDR_ID,HDR_H1_USERID,HDR_H1_TIMESTAMP,HDR_H2_USERID,HDR_H2_TIMESTAMP,HDR_VERSION,O_GROUP,O_ID,O_STR,O_ORT,O_PLZ_1,O_PLZ_2,O_PLZ_3,O_PLZ_4,O_STR2,O_STR3,P_SO_FLAG,P_EU_FLAG,P_WQM,P_NQM,P_SO_BNK,P_UE_BNK,P_KR_BNK,P_ERFOLG,P_STEUER,P_BAUJAHR,P_ATLQM,P_KKLMI,P_STR4,P_STR5,P_ANTEIL_1,P_ANTEIL_2,P_ANTEIL_3,P_ANTEIL_4,P_ANTEIL_5,P_ANTEIL_6,P_ANTEIL_7,P_ANTEIL_8,P_ANTEIL_9,P_ANTEIL_10,P_ANZ_HS,P_ANZ_WO,P_ANZ_GEW,P_ANZ_GA,P_GAQM,P_GROUPID,P_BELWERT,OBJNR,MANDANT,PERSONS,BPRM_BU_LAUF,BPRM_BU_NO,HBJ,OWNER_1,OWNER_2,OWNER_3,OWNER_4,OWNER_5,OWNER_6,OWNER_7,OWNER_8,OWNER_9,OWNER_10,OWNER_11,JUE,KSBNO,KPBNO,ZUWEIS_1,ZUWEIS_2,ZUWEIS_3,ZUWEIS_4,ZUWEIS_5,ZUWEIS_6,ZUWEIS_7,ZUWEIS_8,ZUWEIS_9,BELGRENZE,INTERMODELL,OBJMODELL,OBJTYP,DSTOCKWERT,WWID,DWVERWALTUNGSBEGINN,DWVERWALTUNGSENDE,MARKTWERT,WRNGID_BELWERT,WRNGID_BELGRENZE,WRNGID_DSTOCKWERT,WRNGID_MARKTWERT,WAEHRUNGSCODE,VERWALTUNGSTYP,BUPERMONAT,BUPERJAHR,VERWALTUNGSOBJ,BUKRNR,USTID,BLKENNUNG,STEUERNR,LLKZID,LREGIONID,GLAEUBIGERID,NVNRUECK,OLDFLG,OBJARTID,N15AABDAT,MANREFMANUELL,P_KEU_FLAG,P_KR_UE_BNK,VKONTOMANUELL,VTOPTBTKREISAKTIV,LSEVPARAMID,P_KTN_BNK,P_MAHN_VWENDE_FLAG,BUKREISID',
    allowedFilters: ['objnr', 'OBJ_FIBUNR'],
}

const castToType = (val: any) => {
    return Number(val)
}

export const IxObjectLookupFieldsConf = {
    'HDR_ID': { type: 'number' },
    'HDR_H1_USERID': { type: 'number' },
    'HDR_H1_TIMESTAMP': { type: 'date' },
    'HDR_H2_USERID': { type: 'number' },
    'HDR_H2_TIMESTAMP': { type: 'date' },
    'HDR_VERSION': { type: 'number' },
    'O_GROUP': { type: 'string' },
    'O_ID': { type: 'string' },
    'O_STR': { type: 'string' },
    'O_ORT': { type: 'string' },
    'O_PLZ_1': { type: 'string' },
    'O_PLZ_2': { type: 'string' },
    'O_PLZ_3': { type: 'string' },
    'O_PLZ_4': { type: 'string' },
    'O_STR2': { type: 'string' },
    'O_STR3': { type: 'string' },
    'P_SO_FLAG': { type: 'string' },
    'P_EU_FLAG': { type: 'string' },
    'P_WQM': { type: 'number.2' },
    'P_NQM': { type: 'number.2' },
    'P_SO_BNK': { type: 'string' },
    'P_UE_BNK': { type: 'string' },
    'P_KR_BNK': { type: 'string' },
    'P_ERFOLG': { type: 'string' },
    'P_STEUER': { type: 'string' },
    'P_BAUJAHR': { type: 'string' },
    'P_ATLQM': { type: 'string' },
    'P_KKLMI': { type: 'string' },
    'P_STR4': { type: 'string' },
    'P_STR5': { type: 'string' },
    'P_ANTEIL_1': { type: 'number.2' },
    'P_ANTEIL_2': { type: 'number.2' },
    'P_ANTEIL_3': { type: 'number.2' },
    'P_ANTEIL_4': { type: 'number.2' },
    'P_ANTEIL_5': { type: 'number.2' },
    'P_ANTEIL_6': { type: 'number.2' },
    'P_ANTEIL_7': { type: 'number.2' },
    'P_ANTEIL_8': { type: 'number.2' },
    'P_ANTEIL_9': { type: 'number.2' },
    'P_ANTEIL_10': { type: 'number.2' },
    'P_ANZ_HS': { type: 'string' },
    'P_ANZ_WO': { type: 'string' },
    'P_ANZ_GEW': { type: 'string' },
    'P_ANZ_GA': { type: 'string' },
    'P_GAQM': { type: 'number.2' },
    'P_GROUPID': { type: 'number' },
    'P_BELWERT': { type: 'number.2' },
    'OBJNR': { type: 'number' },
    'MANDANT': { type: 'number' },
    'PERSONS': { type: 'number' },
    'BPRM_BU_LAUF': { type: 'number' },
    'BPRM_BU_NO': { type: 'number' },
    'HBJ': { type: 'number' },
    'OWNER_1': { type: 'number' },
    'OWNER_2': { type: 'number' },
    'OWNER_3': { type: 'number' },
    'OWNER_4': { type: 'number' },
    'OWNER_5': { type: 'number' },
    'OWNER_6': { type: 'number' },
    'OWNER_7': { type: 'number' },
    'OWNER_8': { type: 'number' },
    'OWNER_9': { type: 'number' },
    'OWNER_10': { type: 'number' },
    'OWNER_11': { type: 'number' },
    'JUE': { type: 'number' },
    'KSBNO': { type: 'number' },
    'KPBNO': { type: 'number' },
    'ZUWEIS_1': { type: 'number' },
    'ZUWEIS_2': { type: 'number' },
    'ZUWEIS_3': { type: 'number' },
    'ZUWEIS_4': { type: 'number' },
    'ZUWEIS_5': { type: 'number' },
    'ZUWEIS_6': { type: 'number' },
    'ZUWEIS_7': { type: 'number' },
    'ZUWEIS_8': { type: 'number' },
    'ZUWEIS_9': { type: 'number' },
    'BELGRENZE': { type: 'number.2' },
    'INTERMODELL': { type: 'number' },
    'OBJMODELL': { type: 'string' },
    'OBJTYP': { type: 'number' },
    'DSTOCKWERT': { type: 'number.2' },
    'WWID': { type: 'string' },
    'DWVERWALTUNGSBEGINN': { type: 'date' },
    'DWVERWALTUNGSENDE': { type: 'date' },
    'MARKTWERT': { type: 'number.2' },
    'WRNGID_BELWERT': { type: 'number' },
    'WRNGID_BELGRENZE': { type: 'number' },
    'WRNGID_DSTOCKWERT': { type: 'number' },
    'WRNGID_MARKTWERT': { type: 'number' },
    'WAEHRUNGSCODE': { type: 'number' },
    'VERWALTUNGSTYP': { type: 'number' },
    'BUPERMONAT': { type: 'number' },
    'BUPERJAHR': { type: 'number' },
    'VERWALTUNGSOBJ': { type: 'number' },
    'BUKRNR': { type: 'number' },
    'USTID': { type: 'string' },
    'BLKENNUNG': { type: 'number' },
    'STEUERNR': { type: 'string' },
    'LLKZID': { type: 'number' },
    'LREGIONID': { type: 'number' },
    'GLAEUBIGERID': { type: 'string' },
    'NVNRUECK': { type: 'number' },
    'OLDFLG': { type: 'number' },
    'OBJARTID': { type: 'number' },
    'N15AABDAT': { type: 'date' },
    'MANREFMANUELL': { type: 'number' },
    'P_KEU_FLAG': { type: 'string' },
    'P_KR_UE_BNK': { type: 'string' },
    'VKONTOMANUELL': { type: 'number' },
    'VTOPTBTKREISAKTIV': { type: 'number' },
    'LSEVPARAMID': { type: 'number' },
    'P_KTN_BNK': { type: 'string' },
    'P_MAHN_VWENDE_FLAG': { type: 'string' },
    'BUKREISID': { type: 'number' },
}

export const useIxObjectLookupData = (
    active=true,
    valueExpr: string = _valueExpr,
    {
        fibuNr,
    }: any = {}
) => {
    const dispatch = useAppDispatch()
    const params = useMemo<any>(() => {
        let params = {}
            if (fibuNr !== undefined) {
                params = {...params, obj_fibunr: fibuNr }
            }
        return params
    }, [fibuNr])
    const { data } = useSelector((state: RootState) => lookupDataSelector(
        state,
        'IxObjectLookup',
        params
    ))
    const [lookupMap, setLookupMap] = useState<any>(null)
    const { paddings } = useSelector((state: RootState) => state.ui)

    const {value: number} = useSelector((state: RootState) => settingsMenuSelector(state, Settings.lookupNumberFormat))
    const {value: separator} = useSelector((state: RootState) => settingsMenuSelector(state, Settings.lookupSeparatorFormat))
    const {value: info} = useSelector((state: RootState) => settingsMenuSelector(state, Settings.lookupInfoFormat))

    const loadData = useCallback((force=false) => {
        dispatch(fetchLookupData({ lookupName: 'IxObjectLookup', url: fetchConfig.url, params, force }))
    }, [dispatch, params])

    useEffect(() => {
        loadData()
    }, [loadData])

    const format = useCallback((x: any) => {
        return `${number.prefix}${zeroPad(x.OBJNR, paddings['OBJNR'])}${number.suffix}${separator.value}${info.prefix} ${x.O_ID !== null && x.O_ID !== undefined ? x.O_ID : ''}${info.suffix}`
    }, [number, paddings, separator, info])

    useEffect(() => {
        if (data) {
            const typesMap = data.map((t: any) => ({
                id: t[valueExpr],
                value: format(t),
            }))
            setLookupMap(typesMap)
        }
    }, [data, format, valueExpr])

    const getFormat = useCallback((objnr: any, ) => {
        if (lookupMap) {
            const item = lookupMap.find((x: any) => {
                return x.id == objnr  // eslint-disable-line eqeqeq
            })
            return item ? item.value : ''
        }
        return ''
    }, [lookupMap])

    const getLookupValue = useCallback((val: any) => {
        
        if (data) {
            const item = data.find((x: any) => {
                return x[valueExpr] == val  // eslint-disable-line eqeqeq
            })

            return item
        }
        return undefined
    }, [data, valueExpr])

    return {
        data,
        format,
        getFormat,
        getLookupValue,
        loadData,
        lookupMap,
    }
}


export type IIxObjectLookupProps = {
    name: string,  // field name in the formik form, would also be used in the lookup context
    readOnly: boolean,
    active?: boolean,
    label?: string,
    onLoadingChanged?: (name: string, isLoading: boolean) => void,
    selectionMode?: 'single' | 'multi' | 'multicsv' | 'range' | 'singlerange',
    getFirstCtxValue?: boolean,
    visible?: boolean,
    openDropdown?: boolean,
    onInfoChange?: any,
    valueExpr?: string,
    updateField?: any,
    fibuNr?: string | number | null,
}

export const IxObjectLookup = ({
    name,
    readOnly,
    active=true,
    label,
    onLoadingChanged,
    selectionMode='single',
    getFirstCtxValue=false,
    visible=true,
    openDropdown=false,
    onInfoChange,
    valueExpr=_valueExpr,
    updateField,
    fibuNr = null,
}: IIxObjectLookupProps) => {
    const { t } = useTranslation()

    const baseLookup = useRef<any>(null)
    const [field] = useField(name)

    const [firstRender, setFirstRender] = useState(true)
    const lastFormikValue = useRef(null)
    const { paddings } = useSelector((state: RootState) => state.ui)

    const {value: number} = useSelector((state: RootState) => settingsMenuSelector(state, Settings.lookupNumberFormat))
    const {value: separator} = useSelector((state: RootState) => settingsMenuSelector(state, Settings.lookupSeparatorFormat))
    const {value: info} = useSelector((state: RootState) => settingsMenuSelector(state, Settings.lookupInfoFormat))

    const [value, setValue] = useState<any>(null)
    const [callbacks, setCallbacks] = useState<{[k: string]: (v: any, force?: boolean) => void}>({})
    const { data, load, loadItem, loading, reset, setData, dataLoaded, lastParams } = useLookupFetch(fetchConfig)  // eslint-disable-line @typescript-eslint/no-unused-vars

    const { setFieldValue: setLookupFieldValue, getFieldValue: getLookupFieldValue,
        getFieldReadOnly: getLookupFieldReadOnly } = useIxLookupContext()

    const extraFilters = useMemo(() => {
        const filters: any = {}

        filters['obj_fibunr'] = fibuNr

        return filters
    }, [fibuNr])

    const contextFilters = useFiltersList(undefined, undefined, extraFilters)
    const setContextFilter = contextFilters.setFilter
    const { setFieldValue } = useFormikContext()

    const openLookup = useCallback((searchText: string | undefined, rangeStart?: string) => {
        if (!dataLoaded) { load(contextFilters.state).then(() => baseLookup.current?.open(searchText, rangeStart)) }
        else { baseLookup.current?.open(searchText, rangeStart) }
    }, [dataLoaded, load, contextFilters.state])


    // formating function to modify displayed value
    const format = useCallback((x: any) => {
        if (x) {
            return `${number.prefix}${zeroPad(x.OBJNR, paddings['OBJNR'])}${number.suffix}${separator.value}${info.prefix} ${x.O_ID !== null && x.O_ID !== undefined ? x.O_ID : ''}${info.suffix}`
        } else {
            return field.value ? `${number.prefix}${zeroPad(field.value, paddings['OBJNR'])}${number.suffix}` : ''
        }
    }, [field.value, number, paddings, separator, info])

    const rangeFormat = useCallback((x: any, full: boolean) => {
        if (x) {
            if (full) {
                return `${number.prefix}${zeroPad(x.OBJNR, paddings['OBJNR'])}${number.suffix}`
            } else {
                return `${x.OBJNR ? zeroPad(x.OBJNR, paddings['OBJNR']) : ''}`
            }
        } else {
            return `${field.value ? zeroPad(field.value, paddings['OBJNR']) : ''}`
        }
    }, [field.value, number, paddings])

    const handleSelectionChanged = useSelectionChangedCallback({
        value,
        setValue,
        selectionMode,
        displayExpr: rangeFormat
    })

    const handleInputChanged = useInputChangedCallback({
        inputRe,
        getLookupFieldReadOnly,
        loadItem,
        handleSelectionChanged,
        globalFilters: contextFilters.state,
        openLookup,
        selectionMode,
        setValue,
    })

    // call onLoadingChanged callback if available
    useEffect(() => {
        onLoadingChanged && onLoadingChanged(name, loading)
    }, [onLoadingChanged, loading, name])

    useEffect(() => {
        if (value && typeof value !== 'string' && updateField?.name && updateField?.column) {
            Array.isArray(value)
                ? setFieldValue(updateField.name, `${value.map((x: any) => x[updateField.column]).join(',')}`, true)
                : setFieldValue(updateField.name, value[updateField.column], true)
        }

    },[setFieldValue, updateField?.name, updateField?.column, value])

    // if formik value changes update lookup
    useEffect(() => {
        if (firstRender || !active || _.isEqual(field.value, lastFormikValue.current)) { return }

        if (selectionMode === 'range') {
            lastFormikValue.current = field.value
            setValue(field.value)
        } else {
            lastFormikValue.current = field.value

            if (_.isNil(value) && _.isNil(field.value)) { return }
            else if (_.isNil(field.value)) { handleSelectionChanged(null); return }

            let field_value = field.value;
            if (selectionMode === 'multicsv' && typeof(field.value) === 'string') {
                field_value = field.value.split(',').map((x: string) => ixStringToInt(x))
            }

            if (Array.isArray(field_value)) {
                if (_.isNil(value) || !_.isEqual(value.map((x: any) => x[valueExpr]), field_value)) {
                    if (field_value) {
                        load(contextFilters.state)
                            .then((data: any) => handleSelectionChanged(data.filter((x: any) => field_value.includes(x[valueExpr]))))
                            .catch(() => {})
                    } else {
                        handleSelectionChanged(field_value)
                    }
                }
            } else {
                if (_.isNil(value) || value[valueExpr] !== field_value) {
                    if (field_value) {
                        loadItem(contextFilters.state, { [valueExpr]: field_value })
                            .then((data: any) => handleSelectionChanged(data))
                            .catch(() => {})
                    } else {
                        handleSelectionChanged(field_value)
                    }
                }
            }
        }
    }, [field.value, active, firstRender, contextFilters.state, load,
        loadItem, handleSelectionChanged, selectionMode, value,
        valueExpr])

    useEffect(() => {
        if (readOnly && field.value && selectionMode !== 'range' && !_.isEqual(field.value, lastFormikValue.current)) {
            if (value !== null) { return }

            lastFormikValue.current = field.value

            if (selectionMode === 'single') {
                loadItem(contextFilters.state, { [valueExpr]: field.value })
                    .then(res => handleSelectionChanged(res))
                    .catch(() => {})
            } else {
                load(contextFilters.state)
                    .then((data: any) => handleSelectionChanged(data.filter((x: any) => field.value.includes(x[valueExpr]))))
                    .catch(() => {})
            }
        }
    }, [loadItem, load, field.value, value, contextFilters.state, readOnly,
        handleSelectionChanged, selectionMode, valueExpr])

    useEffect(() => {
        if (!firstRender) { return }

        const val = getLookupFieldValue(name)
        if (selectionMode === 'multi') {
            if (val && Array.isArray(val)) {
                const vIds = val.map((v: any) => v && typeof(v) === 'object' ? v[valueExpr] : null).filter((v: any) => v)
                if (vIds.length === val.length && _.isEqual(vIds, field.value)) {
                    setValue(val)
                    setData(val)
                    lastFormikValue.current = field.value
                }
            }
        } else if (selectionMode === 'multicsv') {
            if (val && Array.isArray(val)) {
                const vIds = val.map((v: any) => v && typeof(v) === 'object' ? v[valueExpr] : null).filter((v: any) => v).join(', ')
                if (_.isEqual(vIds, field.value)) {
                    setValue(val)
                    setData(val)
                    lastFormikValue.current = field.value
                }
            }
        } else {
            if (selectionMode === 'single' && val && typeof(val) === 'object' && field.value === val[valueExpr]) {
                setValue(val)
                setData([val])
                lastFormikValue.current = field.value
            } else if (selectionMode === 'range' && val) {
                setValue(val)
            }
        }

        if (field.value === null && val) {
            setLookupFieldValue(name, null)
        }

        setFirstRender(false)
    }, [firstRender, setContextFilter, getLookupFieldValue, field.value, name, setData,
        setLookupFieldValue, selectionMode, getFirstCtxValue, valueExpr])

    // callbacks for changes in lookup context
    const onObjnrChange = useContextSelfCallback({
        valueExpr, contextFilters: contextFilters.state, handleSelectionChanged,
        setData, loadItem, load, castToType, selectionMode
    })

    // update callbacks for fields we're interested in
    useEffect(() => {
        setCallbacks({
            [name]: onObjnrChange,
        })
    }, [name, onObjnrChange])


    const columns = useMemo(() => ([
        {
            dataField: 'HDR_ID',
            dataType: 'number',
            visible: false,
            caption: t('global:field.HDR_ID'),
        },
        {
            dataField: 'OBJNR',
            dataType: 'number',
            visible: true,
            caption: t('global:field.OBJNR'),
        },
        {
            dataField: 'O_ID',
            dataType: 'string',
            visible: true,
            caption: t('object:field.O_ID'),
        },
        {
            dataField: 'O_STR',
            dataType: 'string',
            visible: true,
            caption: t('object:field.O_STR'),
        },
        {
            dataField: 'O_ORT',
            dataType: 'string',
            visible: true,
            caption: t('object:field.O_ORT'),
        },
    ]), [t])

    const customizeColumns = useCallback((columns: any[]) => {
        columns.forEach((col: any) => {
            if (col.dataField === 'OBJNR') {
                col.format = (x: any) => zeroPad(x, paddings['OBJNR'])
            }
        })
    }, [paddings])



    return (
        <BaseLookup
            ref={baseLookup}
            name={name}
            label={label || t('object:label.objectLookup')}
            opts={data}
            readOnly={readOnly}
            valueExpr={valueExpr}
            keyExpr='HDR_ID'
            displayExpr={format}
            inputExpr={inputFormat}
            loading={loading}
            selectionMode={selectionMode}
            visible={visible}
            customizeColumns={customizeColumns}

            onInputChanged={handleInputChanged}
            onSelectionChanged={handleSelectionChanged}

            value={value}
            callbacks={callbacks}

            contextFilters={contextFilters}
            loadFn={load}
            resetFn={reset}

            columns={columns}

            openDropdown={openDropdown}
            onInfoChange={onInfoChange}

            shouldUpdate={shouldUpdateConfig}
            getFirstCtxValue={getFirstCtxValue}

            dataLoaded={dataLoaded}



            placeholder={ value === 0 ? '----' : '' }
        />
    )
}
